import React, { useEffect, useState, useRef } from 'react';
const purchases = [{
  name: 'Laura M.',
  city: 'Buenos Aires',
  initials: 'LM',
  product: 'Megapack Kinesiología Resuelta',
  time: 'hace 2 min'
}, {
  name: 'Martín C.',
  city: 'Rosario',
  initials: 'MC',
  product: 'Megapack + Método KINE-PRO',
  time: 'hace 5 min'
}, {
  name: 'Sofía V.',
  city: 'Córdoba',
  initials: 'SV',
  product: 'Megapack + Método KINE-PRO',
  time: 'hace 8 min'
}, {
  name: 'Federico L.',
  city: 'Tucumán',
  initials: 'FL',
  product: 'Megapack Kinesiología Resuelta',
  time: 'hace 12 min'
}, {
  name: 'Diego R.',
  city: 'Mendoza',
  initials: 'DR',
  product: 'Megapack + Método KINE-PRO',
  time: 'hace 15 min'
}, {
  name: 'Valentina T.',
  city: 'Santa Fe',
  initials: 'VT',
  product: 'Megapack + Método KINE-PRO',
  time: 'hace 18 min'
}, {
  name: 'Gabriela R.',
  city: 'Salta',
  initials: 'GR',
  product: 'Megapack Kinesiología Resuelta',
  time: 'hace 22 min'
}, {
  name: 'Carolina P.',
  city: 'La Plata',
  initials: 'CP',
  product: 'Megapack + Método KINE-PRO',
  time: 'hace 25 min'
}, {
  name: 'Daniel S.',
  city: 'Mar del Plata',
  initials: 'DS',
  product: 'Megapack Kinesiología Resuelta',
  time: 'hace 30 min'
}, {
  name: 'Julián F.',
  city: 'Neuquén',
  initials: 'JF',
  product: 'Megapack + Método KINE-PRO',
  time: 'hace 35 min'
}, {
  name: 'Romina G.',
  city: 'San Juan',
  initials: 'RG',
  product: 'Megapack Kinesiología Resuelta',
  time: 'hace 40 min'
}, {
  name: 'Lucas B.',
  city: 'Paraná',
  initials: 'LB',
  product: 'Megapack + Método KINE-PRO',
  time: 'hace 45 min'
}];
const avatarColors: Record<string, string> = {
  LM: '#0e7490',
  MC: '#7c3aed',
  SV: '#b45309',
  FL: '#065f46',
  DR: '#9f1239',
  VT: '#1d4ed8',
  GR: '#92400e',
  CP: '#0e7490',
  DS: '#7c3aed',
  JF: '#065f46',
  RG: '#b45309',
  LB: '#1d4ed8'
};
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  const indexRef = useRef(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    // Keyframes now in index.css — no need to inject
    function showNext() {
      setCurrent(indexRef.current);
      setVisible(true);
      timeoutRef.current = setTimeout(() => {
        setVisible(false);
        indexRef.current = (indexRef.current + 1) % purchases.length;
        const nextDelay = 12000 + Math.random() * 6000;
        timeoutRef.current = setTimeout(showNext, nextDelay);
      }, 4000);
    }
    timeoutRef.current = setTimeout(showNext, 8000);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  const purchase = current !== null ? purchases[current] : null;
  if (!purchase) return null;
  const bgColor = avatarColors[purchase.initials] || '#0077B6';
  const isPro = purchase.product.includes('KINE-PRO');
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs" style={{
    animation: visible ? 'notifIn 0.3s ease-out forwards' : 'notifOut 0.3s ease-in forwards',
    pointerEvents: 'none'
  }} data-id="element-276">
      <div className="flex items-center gap-3 bg-white rounded-xl shadow-lg px-4 py-3" style={{
      border: '1px solid rgba(0,119,182,0.20)'
    }} data-id="element-277">
        {/* Avatar */}
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-black text-white" style={{
        backgroundColor: bgColor
      }} data-id="element-278">
          {purchase.initials}
        </div>

        {/* Content */}
        <div className="min-w-0" data-id="element-279">
          <p className="text-xs font-bold text-gray-900 m-0 truncate" data-id="element-280">
            {purchase.name} — {purchase.city}
          </p>
          <p className="text-[10px] text-gray-500 m-0 truncate" data-id="element-281">
            Compró{' '}
            <span className="font-bold" style={{
            color: isPro ? '#0077B6' : '#374151'
          }} data-id="element-282">
              {purchase.product}
            </span>
          </p>
          <p className="text-[10px] font-semibold m-0" style={{
          color: '#0077B6'
        }} data-id="element-283">
            ✓ {purchase.time}
          </p>
        </div>
      </div>
    </div>;
}